import { FaStar } from "react-icons/fa6";
export default function TopBrandBadge({ className = '' }) {
    return (
        <div className={`
            relative px-2 py-0.5 text-10 font-text rounded-full transition-all font-medium
            bg-gradient-title  text-white shadow-sm
            w-fit flex items-center justify-center overflow-hidden
            ${className}
          `}>
        <FaStar className="size-3 mr-1" />
        TOP BRAND
    </div>
    );
}